if (!customElements.get('color-swatch')) {
	class ColorSwatch extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.optionNodes = this.querySelectorAll('[data-value]')
			this.init()
		}

		disconnectedCallback() {
			this.optionNodes.forEach(button => button.removeEventListener('mouseenter', this.onMouseEnter.bind(this)))
		}

		init() {
			const productCard = this.closest('.product-card')
			this.mainImage = productCard.querySelector('.product-card__image--main img')
			this.mainLink = productCard.querySelector('.product-card__link')
			this.detailsLink = productCard.querySelector('.biky-card__choose')
			this.optionNodes.forEach(button => button.addEventListener('mouseenter', this.onMouseEnter.bind(this)))

			this.selected = this.querySelector('[aria-selected="true"]')

			this.getVariantData()
			this.initOptionSwatches()
		}

		initOptionSwatches() {
			const {colorSwatches = []} = window.FoxThemeSettings
			this.optionNodes.forEach(optNode => {
				let variantImage
				const {optionPosition, value: optionValue, fallbackValue} = optNode.dataset
				const variant = this.variantData.find(v =>
					v[`option${optionPosition}`] &&
					v[`option${optionPosition}`].toLowerCase() === optionValue.toLowerCase() &&
					v.featured_image
				) ||
				this.variantData.find(v =>
					v[`option${optionPosition}`] &&
					v[`option${optionPosition}`].toLowerCase() === optionValue.toLowerCase()
				)
				const check = colorSwatches.find(c => c.key.toLowerCase() === optionValue.toLowerCase())
				const customColor = check ? check.value : ''
				const {optionImage} = optNode.dataset

				if (variant) {
					variantImage = variant.featured_image ? variant.featured_image.src : ''
					optNode.href = `${optNode.href}?variant=${variant.id}`
					if (variantImage) {
						if (!optionImage && !customColor) {
							optNode.style = `background-image: url(${ getSizedImageUrl(variantImage, '60x')}) !important;`
						}
						optNode.setAttribute('data-src', getSizedImageUrl(variantImage, '900x'))
						optNode.setAttribute('data-srcset', getSrcset(variantImage))
					}
					optNode.setAttribute('data-variant-id', variant.id)
				}
				if (!customColor && !variantImage) {
					optNode.style.setProperty('--bg-color', `${fallbackValue}`)
				}
				if (customColor) {
					optNode.style.setProperty('--bg-color', `${customColor}`)
				}

				if (optionImage) {
					optNode.style = `background-image: url(${optionImage}) !important; --bg-color: ${customColor}`
				}
				
				if (optNode.tagName === 'A') {
					optNode.addEventListener('click', (e) => {
						if (variant) {
							const productCard = this.closest('.product-card')
							const metaDataScript = productCard.querySelector('[type="application/json-lines"]')
							if (metaDataScript) {
								try {
									const metaData = JSON.parse(metaDataScript.textContent)
									const variantMeta = metaData.find(meta => meta.id === variant.id)
									if (variantMeta && variantMeta.values && variantMeta.values.variant_media) {
										e.preventDefault()
										window.location.href = `${optNode.href}?variant=${variant.id}`
										return false
									}
								} catch (error) {
									console.warn('Error parsing variant metadata:', error)
								}
							}
						}
					})
				}
			})
		}

		onMouseEnter(e) {
			const {target} = e
			this.selected && this.selected.removeAttribute('aria-selected')
			target.setAttribute('aria-selected', true)

			const {src, srcset, variantId} = target.dataset
			if (this.mainImage && srcset) {
				this.swapImageWhenLoaded(src, srcset)
			}

			if (this.mainLink && variantId) {
				const baseUrl = this.mainLink.href.split('?')[0]
				this.mainLink.href = `${baseUrl}?variant=${variantId}`
			}
			if (this.detailsLink && variantId) {
				const baseUrl = this.detailsLink.href.split('?')[0]
				this.detailsLink.href = `${baseUrl}?variant=${variantId}`
			}

			// --- ОБНОВЛЕНИЕ ДАННЫХ ПРИ НАВЕДЕНИИ ---
			if (variantId) {
				const variant = this.variantData.find(v => v.id === parseInt(variantId))
				if (variant) {
					this.updatePrice(variant)
					this.updateBadge(variant)
					this.updateProperties(variant)
                    this.updateCartForm(variantId)
                }
			}

			this.selected = target
		}

		// Swap the image only once the new one has fully loaded so the old photo stays
		// in place instead of lingering under already-updated data. The spinner is
		// delayed so fast/cached loads don't flash it.
		swapImageWhenLoaded(src, srcset) {
			if (this.mainImage.getAttribute('src') === src) return

			const host = this.mainImage.closest('.product-card__image-wrapper')
			// Ignore a stale load when the user hovers another swatch meanwhile.
			const token = (this._swapToken = (this._swapToken || 0) + 1)

			const spinnerTimer = setTimeout(() => {
				if (token === this._swapToken && host) host.classList.add('is-loading-swap')
			}, 150)

			const finish = (apply) => {
				clearTimeout(spinnerTimer)
				if (token !== this._swapToken) return
				if (apply) {
					this.mainImage.src = src
					this.mainImage.srcset = srcset
				}
				if (host) host.classList.remove('is-loading-swap')
			}

			const preloader = new Image()
			preloader.sizes = this.mainImage.sizes || ''
			preloader.onload = () => finish(true)
			preloader.onerror = () => finish(false)
			preloader.srcset = srcset
			preloader.src = src
		}

		getVariantData() {
            let variantDataElement = this.nextElementSibling
            if (variantDataElement) {
                this.variantData = this.variantData || JSON.parse(variantDataElement.textContent)

                let variantMetaDataElement = variantDataElement.nextElementSibling

                if (variantMetaDataElement) {
                    this.variantMetaData = this.variantMetaData || JSON.parse(this.nextElementSibling.nextElementSibling.textContent)
                }
            }
		}

		// === МЕТОДЫ ОБНОВЛЕНИЯ ===

		updatePrice(variant) {
			const productCard = this.closest('.product-card')
			const priceContainer = productCard.querySelector('.f-price')
			const regularPrice = productCard.querySelector('.f-price-item--regular')
			const salePrice = productCard.querySelector('.f-price-item--sale')
			const compareRow = productCard.querySelector('.f-price__compare-row')
			const compareBreak = productCard.querySelector('.f-price__compare-break')

			if (!salePrice) return

			// Форматируем цену
			const format = window.FoxThemeSettings ? window.FoxThemeSettings.moneyFormat : '${{amount}}'
			
			// Обновляем текущую цену
			salePrice.innerHTML = formatMoney(variant.price, format).replace('.00', '')

			// Обновляем старую цену (compare_at_price)
			if (regularPrice) {
				if (variant.compare_at_price && variant.compare_at_price > variant.price) {
					regularPrice.innerHTML = formatMoney(variant.compare_at_price, format).replace('.00', '')
					regularPrice.style.visibility = 'visible'
					if (compareRow) compareRow.style.display = ''
					if (compareBreak) compareBreak.style.display = ''
					priceContainer && priceContainer.classList.add('f-price--on-sale')
				} else {
					regularPrice.style.visibility = 'hidden'
					if (compareRow) compareRow.style.display = 'none'
					if (compareBreak) compareBreak.style.display = 'none'
					priceContainer && priceContainer.classList.remove('f-price--on-sale')
				}
			}
		}

		updateBadge(variant) {
			const productCard = this.closest('.product-card')
			const badgesContainer = productCard.querySelector('.product-card__badges')
			const badgeSale = productCard.querySelector('.product-badge--sale')
			const badgeLe = productCard.querySelector('.product-badge--le')

			if (badgeSale) {
				if (variant.compare_at_price && variant.compare_at_price > variant.price) {
					const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
					badgeSale.textContent = `-${discount}%`
					badgeSale.style.display = 'block'
				} else {
					badgeSale.style.display = 'none'
				}
			}

			const isLE = variant.option1 === 'LE' || variant.option2 === 'LE' || variant.option3 === 'LE'

			if (badgeLe) {
				badgeLe.style.display = isLE ? (badgeLe.classList.contains('biky-card__benefit--le') ? 'inline-flex' : 'block') : 'none'
			}

			productCard.classList.toggle('product-card--le', isLE)

			if (badgesContainer) {
				const anyVisible = [...badgesContainer.querySelectorAll('.product-badge')].some(b => b.style.display !== 'none')
				badgesContainer.style.display = anyVisible ? 'flex' : 'none'
			}
		}

		updateProperties(variant) {
			const productCard = this.closest('.product-card')
			const propsContainer = productCard.querySelector('.product-card__specifications')
			if (!propsContainer) return

			// Получаем дефолтные значения size и age из data-атрибутов (от продукта)
			const defaultSize = propsContainer.dataset.size || ''
			const defaultAge = propsContainer.dataset.age || ''

			// Ищем метаданные для этого варианта
			const variantMeta = (this.variantMetaData || []).find(m => m.id === variant.id)
			let parts = []

			// 1. SIZE
			if (defaultSize) parts.push(defaultSize)

			// 2. WEIGHT (variant_weight или weight) - из варианта
			if (variantMeta && variantMeta.values) {
				const vals = variantMeta.values
				const wObj = vals.variant_weight || vals.weight
				if (wObj) {
					if (typeof wObj === 'object' && wObj !== null && wObj.value) {
						let unit = wObj.unit || 'lbs'
						if (unit === 'lb') unit = 'lbs'
						parts.push(`${wObj.value} ${unit}`)
					} else if (typeof wObj === 'string' || typeof wObj === 'number') {
						let display = String(wObj)
						if (!display.includes('lbs')) display = display.replace(' lb', ' lbs')
						parts.push(display)
					}
				}
			}

			// 3. AGE
			if (defaultAge) parts.push(defaultAge)

			// 4. HEIGHT (variant_height или height) - из варианта
			if (variantMeta && variantMeta.values) {
				const vals = variantMeta.values
				const hObj = vals.variant_height || vals.height
				if (hObj) {
					if (Array.isArray(hObj) && hObj.length >= 2) {
						const min = hObj[0].value
						const max = hObj[hObj.length - 1].value
						parts.push(`Height ${min}"-${max}"`)
					} else if (Array.isArray(hObj) && hObj.length === 1) {
						parts.push(`Height ${hObj[0].value}"`)
					} else if (typeof hObj === 'object' && hObj !== null && hObj.value) {
						parts.push(`Height ${hObj.value}"`)
					} else if (typeof hObj === 'string' || typeof hObj === 'number') {
						parts.push(`Height ${String(hObj).replace(' inches', '')}"`)
					}
				}
			}

			// Обновляем структурированные характеристики новой BEM-карточки.
			const sizeNode = productCard.querySelector('[data-spec="size"]')
			const weightNode = productCard.querySelector('[data-spec="weight"]')
			const weightContainer = productCard.querySelector('[data-spec-container="weight"]')
			if (sizeNode && defaultSize) sizeNode.textContent = defaultSize

			if (weightNode && weightContainer) {
				const weight = variantMeta && variantMeta.values
					? variantMeta.values.variant_weight || variantMeta.values.weight
					: null
				let weightDisplay = ''

				if (weight && typeof weight === 'object' && weight.value != null) {
					const unit = weight.unit === 'lb' ? 'lbs' : (weight.unit || 'lbs')
					weightDisplay = `${weight.value} ${unit}`
				} else if (weight !== null && weight !== undefined && weight !== '') {
					weightDisplay = String(weight).replace(/\blb\b/, 'lbs')
				}

				weightNode.textContent = weightDisplay
				weightContainer.hidden = weightDisplay === ''
			}

			// Обновляем скрытую строку совместимости.
			if (parts.length > 0) {
				propsContainer.textContent = parts.join(' | ')
				propsContainer.style.display = 'block'
			} else {
				// Если ничего не собрали, скрываем
				propsContainer.style.display = 'none'
			}
		}

        updateCartForm(variantId) {
            const productCard = this.closest('.product-card')
            const cartForm = productCard.querySelector('.product-card-form')

            if (!cartForm) return

            const variantInput = cartForm.querySelector('input[name="id"]')
            if (variantInput) {
                variantInput.value = variantId
            }

            // Также обновляем доступность кнопки, если вариант недоступен
            const addToCartButton = cartForm.querySelector('button[name="add"]')
            if (addToCartButton) {
                const variant = this.variantData.find(v => v.id === parseInt(variantId))
                if (variant) {
                    if (variant.available) {
                        addToCartButton.disabled = false
                        addToCartButton.removeAttribute('disabled')
                    } else {
                        addToCartButton.disabled = true
                        addToCartButton.setAttribute('disabled', 'disabled')
                    }
                }
            }
        }
	}
	customElements.define('color-swatch', ColorSwatch)
}
